define('modules/uv-shared-module/DownloadOption',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DownloadOption;
    (function (DownloadOption) {
        DownloadOption["CANVAS_RENDERINGS"] = "canvasRenderings";
        DownloadOption["CURRENT_VIEW"] = "currentView";
        DownloadOption["ENTIRE_DOCUMENT_AS_PDF"] = "entireDocumentAsPdf";
        DownloadOption["ENTIRE_DOCUMENT_AS_TEXT"] = "entireDocumentAsText";
        DownloadOption["ENTIRE_FILE_AS_ORIGINAL"] = "entireFileAsOriginal";
        DownloadOption["IMAGE_RENDERINGS"] = "imageRenderings";
        DownloadOption["MANIFEST_RENDERINGS"] = "manifestRenderings";
        DownloadOption["RANGE_RENDERINGS"] = "rangeRenderings";
        DownloadOption["SELECTION"] = "selection";
        //SEQUENCE_RENDERINGS = "sequenceRenderings",
        DownloadOption["UNKNOWN"] = "unknown";
        DownloadOption["WHOLE_IMAGE_HIGH_RES"] = "wholeImageHighRes";
        DownloadOption["WHOLE_IMAGE_LOW_RES"] = "wholeImageLowRes";
        DownloadOption["WHOLE_IMAGES_HIGH_RES"] = "wholeImagesHighRes";
    })(DownloadOption = exports.DownloadOption || (exports.DownloadOption = {}));
});

